import RestService from '../services/rest';

async function getLive() {
  return RestService.getAuthenticated('panel/analytics/live');
}

async function getHistorySummary(startDate, endDate) {
  return RestService.getAuthenticated(
    `panel/analytics/history/summary?startDate=${startDate}&endDate=${endDate}`,
  );
}

async function getCommercialSummary(initialDate, finalDate) {
  return RestService.getAuthenticated(
    `panel/analytics/summary?initialDate=${initialDate}&finalDate=${finalDate}`,
  );
}

async function getHistoryOverview(startDate, endDate) {
  return RestService.getAuthenticated(
    `panel/analytics/history/overview?startDate=${startDate}&endDate=${endDate}`,
  );
}

async function getHistoryTopItems(startDate, endDate, limit = 10) {
  return RestService.getAuthenticated(
    `panel/analytics/history/top-items?startDate=${startDate}&endDate=${endDate}&limit=${limit}`,
  );
}

async function getHistoryAuthMethods(startDate, endDate) {
  return RestService.getAuthenticated(
    `panel/analytics/history/auth-methods?startDate=${startDate}&endDate=${endDate}`,
  );
}

async function getHistoryTimeseries(startDate, endDate, metric) {
  return RestService.getAuthenticated(
    `panel/analytics/history/timeseries?startDate=${startDate}&endDate=${endDate}&metric=${metric}`,
  );
}

async function getHistoryTopPages(startDate, endDate, limit = 10) {
  return RestService.getAuthenticated(
    `panel/analytics/history/top-pages?startDate=${startDate}&endDate=${endDate}&limit=${limit}`,
  );
}

async function getHistoryFunnel(startDate, endDate) {
  return RestService.getAuthenticated(
    `panel/analytics/history/funnel?startDate=${startDate}&endDate=${endDate}`,
  );
}

async function getLakeStatus() {
  return RestService.getAuthenticated('panel/analytics/lake/status');
}

async function listSavedReports() {
  return RestService.getAuthenticated('panel/analytics/saved-reports');
}

async function createSavedReport(body) {
  return RestService.postAuthenticated('panel/analytics/saved-reports', body);
}

async function updateSavedReport(id, body) {
  return RestService.putAuthenticated(`panel/analytics/saved-reports/${id}`, body);
}

async function deleteSavedReport(id) {
  return RestService.deleteAuthenticated(`panel/analytics/saved-reports/${id}`);
}

async function runSavedReport(id, startDate, endDate) {
  const q = startDate && endDate
    ? `?startDate=${startDate}&endDate=${endDate}`
    : '';
  return RestService.getAuthenticated(`panel/analytics/saved-reports/${id}/run${q}`);
}

async function searchJourneyUsers(q, limit = 20) {
  return RestService.getAuthenticated(
    `panel/analytics/journey/search?q=${encodeURIComponent(q)}&limit=${limit}`,
  );
}

async function getJourneyTimeline({ userId, userEmail, startDate, endDate }) {
  const params = new URLSearchParams();
  if (userId) params.set('userId', userId);
  if (userEmail) params.set('userEmail', userEmail);
  if (startDate) params.set('startDate', startDate);
  if (endDate) params.set('endDate', endDate);
  return RestService.getAuthenticated(`panel/analytics/journey/timeline?${params.toString()}`);
}

export default {
  getLive,
  getHistorySummary,
  getCommercialSummary,
  getHistoryOverview,
  getHistoryTopItems,
  getHistoryAuthMethods,
  getHistoryTimeseries,
  getHistoryTopPages,
  getHistoryFunnel,
  getLakeStatus,
  listSavedReports,
  createSavedReport,
  updateSavedReport,
  deleteSavedReport,
  runSavedReport,
  searchJourneyUsers,
  getJourneyTimeline,
};
